import React, { PureComponent } from 'react';
import i18n from '@i18next/i18n';
import AddLocalfileIcon from '@src/framework/editor/src/img/pageIndex/toolbar/toolbar_add_localfile.svg';
import styles from './index.less';

export default class UploadFileTooltip extends PureComponent {
    public render() {
        return (
            <div className={styles['option-menu-item-upload-file-tooltip']}>
                <span className={styles['option-menu-item-upload-file-tooltip-title']}>{i18n.t('本地文件')}</span>
                <img src={AddLocalfileIcon} alt="upload-file" />
                <span className={styles['option-menu-item-upload-file-tooltip-footer']}>
                    {i18n.t('支持本地文件插入，实现便捷分享')}
                </span>
            </div>
        );
    }
}
